import React from "react";

function Canvas_Lines() {
  return (
    <div>
      <h1>Canvas_Lines Component</h1>
      <p>This is the Canvas Lines tutorial page content.</p>
    </div>
  );
}

export default Canvas_Lines;
